/* unplugin-vue-components disabled */import script from "./Cyds.vue?vue&type=script&lang=ts&setup=true"
export * from "./Cyds.vue?vue&type=script&lang=ts&setup=true"

import "./Cyds.vue?vue&type=style&index=0&id=559c6eb0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-559c6eb0"]])

export default __exports__